var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "height": "450px",
      "border": "1px solid #E6E7E9"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "background-color": "#E6E7E9"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "40px",
      "font-weight": "700"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("组织架构：\n\t\t\t\t"), _c('div', {
    staticStyle: {
      "color": "#7a7a7a",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.$globals.group_name + '/' + _vm.from.range))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("起止时间：\n\t\t\t\t"), _c('div', {
    staticStyle: {
      "color": "#7a7a7a",
      "margin-top": "5px"
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.from.start_stop_date[0] + "—" + _vm.from.start_stop_date[1]) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("岗位：\n\t\t\t\t"), _c('div', {
    staticStyle: {
      "color": "#7a7a7a",
      "margin-top": "5px"
    }
  }, _vm._l((_vm.from.postList), function(item) {
    return _c('span', {
      key: item.id
    }, [_vm._v(_vm._s(item.post_name) + ",  ")])
  }), 0)]), _vm._v(" "), _c('div', [_vm._v("合同模板：\n\t\t\t\t"), _c('div', {
    staticStyle: {
      "color": "#000000",
      "margin": "10px 0"
    }
  }, _vm._l((_vm.from.templateList), function(item) {
    return _c('div', {
      key: item.id,
      staticStyle: {
        "display": "inline-block",
        "width": "80px",
        "height": "30px",
        "border": "1px solid #e5e5e5",
        "border-radius": "5px",
        "margin-left": "5px"
      }
    }, [_c('el-row', [_c('el-col', {
      staticStyle: {
        "text-align": "right"
      },
      attrs: {
        "span": 12
      }
    }, [_c('span', {
      staticStyle: {
        "line-height": "30px"
      }
    }, [_vm._v(_vm._s(item.template_name))])]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 10,
        "offset": 2
      }
    }, [_c('img', {
      staticStyle: {
        "margin-top": "6px"
      },
      attrs: {
        "src": require("../../../assets/icon/下载模板.png")
      }
    })])], 1)], 1)
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_vm._v("状态：\n\t\t\t\t"), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.state === '1'),
      expression: "from.state === '1'"
    }],
    staticStyle: {
      "color": "#30c7a9",
      "margin-top": "5px"
    }
  }, [_vm._v("\n\t\t\t\t\t已生效\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.from.state === '0'),
      expression: "from.state === '0'"
    }],
    staticStyle: {
      "color": "#ff9435",
      "margin-top": "5px"
    }
  }, [_vm._v("\n\t\t\t\t\t未生效\n\t\t\t\t")])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "20px",
      "background-color": "#F4F5FA",
      "padding": "12px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px",
      "font-weight": "700"
    }
  }, [_vm._v("合同签订发起详情")])])
}]
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-390f2588","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtqdFQ/HtqdFq_edit.vue
// module id = null
// module chunks = 